import type { IntlFormatters } from "@formatjs/intl/src/types";
import type { IProperty } from "types/jsonSchema";
import { z } from "zod";

export default function parseLanguagesField(field: IProperty, formatMessage: IntlFormatters["formatMessage"]) {
    const { minProperties = 0, propertyNames, additionalProperties } = field;
    const langsEnum = propertyNames?.enum?.map((el) => el.toString()) ?? [];
    const levelEnum = additionalProperties?.enum?.map((el) => el.toString()) ?? [];

    const shape = z
        .array(
            z.object({
                level: z.string(),
                language: z.string(),
            }),
        )
        .superRefine((val, ctx) => {
            if (val.length < minProperties) {
                ctx.issues.push({
                    code: "too_small",
                    input: val,
                    minimum: minProperties,
                    type: "set",
                    inclusive: false,
                    origin: "set",
                    message: formatMessage({
                        id: "errors.invalid_type_received_null",
                    }),
                });
            }

            val.forEach(({ language, level }, index) => {
                if (!level && !language && !minProperties) {
                    return;
                }

                if (!language || !langsEnum.includes(language.toString())) {
                    ctx.issues.push({
                        code: "custom",
                        input: val,
                        path: [index, "language"],
                        message: formatMessage({
                            id: "errors.invalid_type_received_null",
                        }),
                    });
                }

                if (!level || !levelEnum.includes(level.toString())) {
                    ctx.issues.push({
                        code: "custom",
                        input: val,
                        path: [index, "level"],
                        message: formatMessage({
                            id: "errors.invalid_type_received_null",
                        }),
                    });
                }
            });
        })
        .transform((val) =>
            val.reduce((acc, v) => {
                if (v.language.length === 0) return acc;

                Object.assign(acc, { [v.language]: Number(v.level) });

                return acc;
            }, {}),
        );

    return shape;
}
